import styled from "styled-components";
import {Accents, getAccentStyle} from "../../theme/accents";

export const Badge = styled.span<Accents>`
    && {
        font-size: 0.6rem;
        padding: 0.2rem 0.4rem;
        border-radius: 0.2rem;
        background: ${props => getAccentStyle(props).primaryBg};
        color: ${props => getAccentStyle(props).primaryFg};
        font-weight: bold;
        text-decoration: none;
        text-transform: uppercase;
    }
    
    & + & {
        margin-left: .3em;
    }
`;
